<section>
  <div class="row form p-2">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <p>El número de días se aplicara a la fecha compromiso de todos los artículos del pedido.</p>
    </div>
    <div class="row align-items-end">
      <div class="col-lg-4 col-md-2 col-sm-2 col-6">
        <app-custom-input-number #daysCompromiseDateInput id="daysCompromiseDate" [labelText]="'Nro. Días'"
          [required]="true"></app-custom-input-number>
      </div>
      <div class="col-lg-8 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-3 gap-2">
        <app-custom-button [title]="'Aceptar'" [label]="'Aceptar'"
          (onClick)="updateCompromiseDateByOrderId()"></app-custom-button>
        <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'"
          (onClick)="close(false)"></app-custom-button>
      </div>
    </div>
  </div>
</section>